import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import styled from "styled-components";
import { useSnackbar } from "../../../../app/contexts/snackbar.context";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import { useUser } from "../../../../app/contexts/user.context";
import { GetApp as GetAppIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import { useExportPlan } from "../../countries.and.site.groups/country.tabs/controls/export.plan/export.js";
import PrimaryButton from "../../../../app/components/buttons/primary/index.js";
import OutlinedButton from "../../../../app/components/buttons/outlined/index.js";
import TextButton from "../../../../app/components/buttons/text/index.js";
import { usePermissionWrapper } from "../../../../app/contexts/permission.context";
import { validateSeasonalVariations } from "../../validations/validate.study.plan";

const TopControls = ({ errors, warnings }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, planId } = useParams();
  const {
    runSimulation,
    studyPlan,
    validateSequentialCohort,
    isSequential,
  } = useStudyPlan();
  const { scenarioStatus, simOptRunId } = studyPlan;
  const { showSnackbar } = useSnackbar();
  const PermissionWrapper = usePermissionWrapper();
  const classes = useStyles();

  const exportPlan = useExportPlan();
  const { isReadOnlyUser } = useUser();

  const handleBackToList = () => navigate(`/ctpo/study-plans/${id}`);

  const handleCancel = () => navigate(`/ctpo/study-plans/${id}`);

  const handleExportPlan = () => {
    exportPlan();
  };

  const handleRunSimulation = () => {
    if (scenarioStatus === "Draft") {
      const seqValid = isSequential
        ? validateSequentialCohort(location.pathname)
        : true;
      const { seasonalValid } = validateSeasonalVariations(studyPlan);
      if (Object.keys(warnings || {}).length !== 0) {
        showSnackbar(
          <ul>
            {Object.keys(warnings || {}).map((key) => {
              if (key !== "BUTTON_TYPE") return <li>{warnings[key]}</li>;
              return null;
            })}
          </ul>,
          "warning",
        );
      }
      if (Object.keys(errors || {}).length !== 0 ||
        !seqValid ||
        !seasonalValid
      ) {
        showSnackbar(
          <ul>
            {Object.keys(errors || {}).map((key) => {
              if (key !== "BUTTON_TYPE") return <li>{errors[key]}</li>;
              return "";
            })}
            {!seqValid && <li>Sequential cohorts setup is not valid</li>}
            {!seasonalValid && (
              <li>Country enrollment seasonal variations are not valid</li>
            )}
          </ul>,
          "error",
        );
        return;
      }
      runSimulation();
    }
    navigate(`/ctpo/study-plans/${id}/${planId}/simulation`);
  };

  const handleViewSimulation = () => {
    navigate(`/ctpo/study-plans/${id}/${planId}/simulation?type=view`);
  };

  return (
    <Container>
      <TextButton onClick={handleBackToList}>
        <ChevronLeftIcon />
        Back to Study Plan List
      </TextButton>

      <ButtonContainer>
        <TextButton onClick={handleExportPlan}>
          <GetAppIcon classes={classes} /> EXPORT PLAN
        </TextButton>
        {!isReadOnlyUser && (
          <OutlinedButton onClick={handleCancel}>Cancel</OutlinedButton>
        )}
        {(scenarioStatus === "Draft" && !isReadOnlyUser) && (
          <PermissionWrapper>
            <PrimaryButton onClick={handleRunSimulation}>
              Run Simulation
            </PrimaryButton>
          </PermissionWrapper>
        )}

        {simOptRunId !== null && (
          <PrimaryButton onClick={handleViewSimulation}>
            View Simulation
          </PrimaryButton>
        )}
      </ButtonContainer>
    </Container>
  );
};

export default TopControls;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-gap: 1em;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: ".2em",
  },
}));
